// extracted by mini-css-extract-plugin
module.exports = {"smallNav":"header-nav-small-module--small-nav--3-wF4"};